import {Avatar, Modal} from 'antd'
import {comment_removeComment_Api} from 'apis'
import DrawMenu from 'components/drawer/DrawMenu'
import {createAsyncAction} from 'modules/asyncCache'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {useDispatch} from 'react-redux'
import {NotificationActionTypes, successNotify,} from 'views/AppLocals/factory/createNotification'
import {NullAsDefault} from 'views/Shared'
import {PiTrash} from "react-icons/pi";
import {IoEllipsisHorizontal} from "react-icons/io5";
import {BiSolidEdit, BiTrash} from "react-icons/bi";

const menuOptions = {
    edit: {
        label: 'edit',
        value: 'edit',
        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
    },
    delete: {
        label: 'delete',
        value: 'delete',
        icon: <BiTrash size={14} className="text-primary-300"/>,
    },
}

const ResponsesContextMenu = ({item = {}, onEdit = NullAsDefault}) => {
    const t = useTranslate()

    const dispatch = useDispatch()

    const handleSelect =
        ({onDismiss = NullAsDefault}) =>
            ({key}) => {
                switch (key) {
                    case menuOptions.edit.value:
                        onEdit()
                        break
                    case menuOptions.delete.value:
                        Modal.confirm({
                            icon: <PiTrash className="anticon"/>,
                            title: t('are you sure delete this comment'),
                            className: 'custom-modal',
                            okText: t('sure'),
                            cancelText: t('ignore'),
                            okButtonProps: {
                                className: 'no-shadow no-text-shadow no-border rounded-lg',
                                type: 'primary',
                                danger: true,
                            },
                            cancelButtonProps: {
                                className: 'no-shadow no-text-shadow rounded-lg no-border',
                            },
                            onOk: () => {
                                dispatch(
                                    createAsyncAction({
                                        apiInfo: comment_removeComment_Api,
                                        query: {
                                            ':prop': item.container_type,
                                            ':id': item.container_id,
                                            ':comment_id': item.id,
                                        },
                                        onSuccess: () => {
                                            successNotify(NotificationActionTypes.DELETE, t)
                                        },
                                    })
                                )
                            },
                        })
                        break
                    default:
                        break
                }
                onDismiss()
            }

    if (!!!item.edit) return null

    return (
        <React.Fragment>
            <DrawMenu
                menu={{
                    items: [menuOptions.edit, menuOptions.delete].map(
                        ({icon, label, value}) => ({
                            key: value,
                            icon,
                            label: (
                                <span style={{fontSize: '0.75rem'}} className="text-color-200">
                                    {t(label)}
                                </span>
                            ),
                        })
                    ),
                    onClick: handleSelect({onDismiss: NullAsDefault})
                }}
                component={
                    <Avatar
                        size={24}
                        icon={<IoEllipsisHorizontal size={16} className="text-color-400 hover:text-color-100"/>}
                        className="flex flex-center background hover:background-200 cursor-pointer absolute right-5 top-5 contextIcon"
                    />
                }>
            </DrawMenu>
        </React.Fragment>
    )
}

export default ResponsesContextMenu
